import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import {
  Copy,
  Paste,
  InsertRowAbove,
  InsertRowBelow,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Undo,
} from "common/icons";
import { withStyles } from "@material-ui/core/styles";
import { Delete, Search } from "@material-ui/icons";
import ToolBarItem from "modules/project/components/layouts/ToolBarItem";
import SearchBox from "modules/project/components/layouts/SearchBox";
import { WBSStore } from "modules/WBS/WBSStore";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";
import { gtag } from "ga-gtag";

const styles = (theme) => ({
  container: {
    height: "33px",
    display: "flex",
    backgroundColor: "#000",
    flexFlow: "row nowrap",
    position: "relative" as any,
  },
  invert: {
    filter: "invert(0.875)",
    "& > svg": {
      color: "red !important",
    },
  },
  showSearchBox: {
    display: "block",
  },
  hideSearchBox: {
    display: "none",
  },
  tooltip: {
    width: "120px",
  },
});

type IProps = {
  classes: any;
};

@observer
class ToolBarTask extends React.Component<IProps> {
  state = {
    openSearch: false,
    teste: "teste",
  };

  toogleSearchBox = () => {
    this.setState((prevState: any) => ({
      openSearch: !prevState.openSearch,
    }));
  };

  isDisabled = (verifyFunction?) =>
    ToolbarTaskStore.isProcessing
      ? true
      : WBSStore.selectedLine.index === -1
      ? true
      : WBSStore.isLoadingOperations === true
      ? true
      : verifyFunction
      ? verifyFunction()
      : false;

  processing = (action) => async () => {
    ToolbarTaskStore.isProcessing = true;
    await action();
    ToolbarTaskStore.isProcessing = false;
  };

  deletar = () => async () => {
    gtag("event", "barra_ferramenta_composicao_excluir", {
      barra_ferramenta_composicao_excluir: 0,
    });
    let lisTasks = WBSStore.recursiveRowGet(WBSStore.selectedLine.id);
    await ToolbarTaskStore.handelActions(ToolbarTaskStore.deleteTaskRow(), {
      originalOperation: "deleteTaskRow",
      undoOperation: "pasteTaskRow",
      data: {
        undoFunction: {
          function: "pasteTaskRow",
          params: [],
          selectedLine: [],
          copiedLine: {
            row: WBSStore.selectedLine,
            data: lisTasks,
          },
        },
        originalFunction: { function: "deleteTaskRow", params: [] },
      },
    });
  };

  render() {
    let { classes } = this.props;
    let borderLeft = "1px solid #595959";
    return (
      <div className={classes.container}>
        <ToolBarItem
          Icon={Copy}
          fontSize={16}
          title={i18n.icons.copy}
          disabled={this.isDisabled()}
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_composicao_copiar", {
              barra_ferramenta_composicao_copiar: 0,
            });
            await ToolbarTaskStore.copyTaskRow();
          })}
        />
        <ToolBarItem
          Icon={Paste}
          fontSize={16}
          title={i18n.icons.paste}
          disabled={this.isDisabled(ToolbarTaskStore.pasteVerify)}
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_composicao_colar", {
              barra_ferramenta_composicao_colar: 0,
            });
            await ToolbarTaskStore.handelActions(
              ToolbarTaskStore.pasteTaskRow(),
              {
                originalOperation: "pasteTaskRow",
                undoOperation: "deleteTaskRow",
                data: {
                  undoFunction: {
                    function: "deleteTaskRow",
                    params: [],
                    selectedLine: [],
                  },
                  originalFunction: { function: "pasteTaskRow", params: [] },
                },
              }
            );
          })}
        />
        <ToolBarItem
          fontSize={21}
          Icon={InsertRowBelow}
          styles={{ borderLeft }}
          title={i18n.icons.insertRowBelow}
          disabled={this.isDisabled()}
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_composicao_inserir_linha_abaixo", {
              barra_ferramenta_composicao_inserir_linha_abaixo: 0,
            });
            await ToolbarTaskStore.handelActions(
              ToolbarTaskStore.createBlankTaskRow("bellow"),
              {
                originalOperation: "createBlankTaskRow",
                undoOperation: "deleteTaskRow",
                data: {
                  undoFunction: {
                    function: "deleteTaskRow",
                    params: [],
                    selectedLine: [],
                  },
                  originalFunction: {
                    function: "createBlankTaskRow",
                    params: ["bellow"],
                  },
                },
              }
            );
          })}
        />
        <ToolBarItem
          fontSize={21}
          Icon={InsertRowAbove}
          title={i18n.icons.insertRowAbove}
          disabled={this.isDisabled()}
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_composicao_inserir_linha_acima", {
              barra_ferramenta_composicao_inserir_linha_acima: 0,
            });
            await ToolbarTaskStore.handelActions(
              ToolbarTaskStore.createBlankTaskRow(),
              {
                originalOperation: "createBlankTaskRow",
                undoOperation: "deleteTaskRow",
                data: {
                  undoFunction: {
                    function: "deleteTaskRow",
                    params: ["bellow"],
                    selectedLine: [],
                  },
                  originalFunction: {
                    function: "createBlankTaskRow",
                    params: [],
                  },
                },
              }
            );
          })}
        />
        <ToolBarItem
          fontSize={19}
          Icon={Delete}
          title={i18n.icons.delete}
          disabled={this.isDisabled()}
          action={this.deletar()}
        />
        <ToolBarItem Icon={ArrowLeft} disabled={true} styles={{ borderLeft }} />
        <ToolBarItem Icon={ArrowRight} disabled={true} />
        <ToolBarItem
          Icon={ArrowUp}
          styles={{ borderLeft }}
          title={i18n.icons.moveup}
          disabled={this.isDisabled(ToolbarTaskStore.moveupVerify)}
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_eap_mover_cima", {
              barra_ferramenta_eap_mover_cima: 0,
            });
            await ToolbarTaskStore.handelActions(
              ToolbarTaskStore.moveTaskRow(),
              {
                originalOperation: "moveTaskRow",
                undoOperation: "moveTaskRow",
                data: {
                  undoFunction: {
                    function: "moveTaskRow",
                    params: ["forward"],
                    selectedLine: [],
                  },
                  originalFunction: { function: "moveTaskRow", params: [] },
                },
              }
            );
          })}
        />
        <ToolBarItem
          Icon={ArrowDown}
          title={i18n.icons.movedown}
          disabled={this.isDisabled(ToolbarTaskStore.movedownVerify)}
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_composicao_mover_baixo", {
              barra_ferramenta_composicao_mover_baixo: 0,
            });
            await ToolbarTaskStore.handelActions(
              ToolbarTaskStore.moveTaskRow("forward"),
              {
                originalOperation: "moveTaskRow",
                undoOperation: "moveTaskRow",
                data: {
                  undoFunction: {
                    function: "moveTaskRow",
                    params: [],
                    selectedLine: [],
                  },
                  originalFunction: {
                    function: "moveTaskRow",
                    params: ["forward"],
                  },
                },
              }
            );
          })}
        />
        {/* <ToolBarItem
          Icon={Undo}
          styles={{ borderLeft }}
          title={i18n.icons.undo}
          disabled={
            ToolbarTaskStore.undoList && ToolbarTaskStore.undoList.length === 0
          }
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_composicao_desfazer", {
              barra_ferramenta_composicao_desfazer: 0,
            });
            await ToolbarTaskStore.handelActions(
              ToolbarTaskStore.undoWBSRow(),
              { originalOperation: "undoWBSRow" }
            );
          })}
        /> */}
        <ToolBarItem
          data-testid="iconButton-ToolBarTaskSearch"
          Icon={Search}
          fontSize={20}
          styles={{ borderLeft }}
          style={{ height: "100%" }}
          disabled={this.isDisabled()}
          action={this.processing(async () => {
            gtag("event", "barra_ferramenta_composicao_pesquisar", {
              barra_ferramenta_composicao_pesquisar: 0,
            });
            await this.toogleSearchBox();
          })}
        />
        <SearchBox
          open={this.state.openSearch}
          onClose={this.toogleSearchBox}
          leftOffset={102}
        />
      </div>
    );
  }
}

export default withStyles(styles)(ToolBarTask);



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/ToolBarTask.tsx